export default __webpack_public_path__ + "static/media/leoseilerweb.b9a3bd36.mp3";